import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
// Get the root element
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}
// Create root and render app
const root = createRoot(container);
root.render(_jsx(AuthProvider, { children: _jsx(App, {}) }));
